// import MainBody from './indexBody';
import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from 'react-router-dom';
import apiRequest from '../../../../utils/apiRequest';
import { PRODUCTS_GET, IMAGE_ADDRESS } from '../../../../apis';
import { handleChangeDataPageCategoryProducts } from '../../../../redux/actions/pages/category/categoryProducts';
import 'swiper/css';
import { LazyLoadImage } from "react-lazy-load-image-component";


const ProductsDesktop = () => {

	const dispatch = useDispatch();

	const { catTitle } = useParams();

	const { isBackdropLoading } = useSelector(state => state.allLoaders);
	const { products, productCount, filters, catPath, sort } = useSelector(state => state.categoryProducts);

	useEffect(() => {
		callApiGetProducts();
	}, [ProductsDesktop, catTitle]);

	const callApiGetProducts = (getParams = "") => {
		if(! isBackdropLoading)
			apiRequest({
			    dispatch,
			    endpoint: (PRODUCTS_GET + catTitle + getParams),
			    method: 'get',
			    onSuccess: (res) => {
			    	dispatch(handleChangeDataPageCategoryProducts('products', res.products));
			    	dispatch(handleChangeDataPageCategoryProducts('productCount', res.productCount));
			    	dispatch(handleChangeDataPageCategoryProducts('catPath', res.catPath));
			    	if(getParams === "")
			    		dispatch(handleChangeDataPageCategoryProducts('filters', res.filters));
			    },
		  	});
	};

	const handleToggleFilterOptions = (index) => {
		let newFilters = [...filters];
		newFilters.map((newFilter, newFilterIndex) => {
			newFilter.showOptions = (index === newFilterIndex && !newFilter.showOptions);
		});
		dispatch(handleChangeDataPageCategoryProducts('filters', newFilters));
	};

	const handleToggleOptionItemSelect = (optionIndex, filterIndex) => {
		let newFilters = [...filters];
		let isSelect = newFilters[filterIndex].options[optionIndex].isSelect;
		newFilters[filterIndex].options[optionIndex].isSelect = !isSelect;
		dispatch(handleChangeDataPageCategoryProducts('filters', newFilters));



		const selectedIds = filters
		  .flatMap(filter => filter.options) // همه گزینه‌ها در یک آرایه
		  .filter(option => option.isSelect) // فقط انتخاب‌شده‌ها
		  .map(option => option.id); // گرفتن id

		const queryString = selectedIds.length > 0 ? `?filter=${selectedIds.join(',')}&sort=${sort}` : `?sort=${sort}`;

		callApiGetProducts(queryString);
	};

	const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};

	const handleSort = (num) => {
		dispatch(handleChangeDataPageCategoryProducts('sort', num));


		const selectedIds = filters
		  .flatMap(filter => filter.options) // همه گزینه‌ها در یک آرایه
		  .filter(option => option.isSelect) // فقط انتخاب‌شده‌ها
		  .map(option => option.id); // گرفتن id

		const queryString = selectedIds.length > 0 ? `?filter=${selectedIds.join(',')}&sort=${num}` : `?sort=${num}`;

		callApiGetProducts(queryString);
	}

    return (

    	<div className="grow bg-neutral-000 flex flex-col w-full items-center styles_BaseLayoutDesktop__content__hfHD1 container-4xl-w px-6 pt-6" style={{paddingTop: '188px'}}>
			<div className="styles_PageLoader--hasPageContainer__gPBo1 hidden">
			</div>
			<nav className="py-2 grow">
				<div>
					<div className="swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events swiper-container-free-mode swiper-container-rtl">
						<div className="swiper-wrapper">
							<div className="swiper-slide swiper-slide-active" style={{width: 'auto', height: 'auto'}}>
								<Link className="text-neutral-500 text-body-2 shrink-0" data-cro-id="plp-burger-menu" to="/">فروشگاه اینترنتی  کوچی
									<span className="mx-3">/
									</span>
								</Link>
							</div>
							{ 
								catPath.map((path, key) => (
									<div key={`cat-path-${key}`} className="swiper-slide swiper-slide-next" style={{width: 'auto', height: 'auto'}}>
										<Link to={path.url && path.url !== 'null' ? `/category/${path.url}` : '#'} className="text-neutral-500 text-body-2 shrink-0" data-cro-id="plp-burger-menu">
											<span className="inline text-neutral-500 text-body-2 ">{path.title}
											</span>
											<span className="mx-3">{catPath[key + 1] !== undefined ? '/' : ''}
											</span>
										</Link>
									</div>
								))

							}
						</div>
					</div>
				</div>
			</nav>
			<div className="flex items-center my-3 lg:mb-5">
				<div className="flex flex-col">
					<h1 className="text-neutral-900 text-h5">{catPath.length > 0 && catPath[catPath.length - 1].title}</h1>
				</div>
			</div>
			<div id="ProductListPagesWrapper" className="relative w-full flex flex-col lg:flex-row items-center lg:items-stretch justify-between product-list_ProductList__wrapper__Evjm8">
				<section className="w-full grow relative">
					<div className="lg:static sticky lg:top-14 top-16 bg-neutral-000 z-2 top-14">
						<div>
							<div className="flex items-center border-complete-b-200 gap-4 sticky top-20 bg-neutral-000 lg:static">
								<div className="flex flex-row items-center gap-x-4 grow">
									<div className="break-words py-3">
										<div className="flex items-center grow">
											<div className="flex shrink-0 ml-2" data-cro-id="plp-sort-icon">
												<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
													<use xlinkHref="#sort"></use>
												</svg>
											</div>
											<p className="grow cursor-pointer whitespace-nowrap text-neutral-700  text-body2-strong">
												<span className="relative">مرتب سازی:
												</span>
											</p>
										</div>
									</div>
									<div className="styles_HeaderSort__SortList__OPEV3">
										<span onClick={() => handleSort("1")} className={`cursor-pointer whitespace-nowrap ${sort === '1' ? 'text-body2-strong text-primary-700' : 'text-body-2 text-neutral-500'}`} >
											پرفروش‌ترین‌
										</span>
										<span onClick={() => handleSort("2")} className={`cursor-pointer whitespace-nowrap ${sort === '2' ? 'text-body2-strong text-primary-700' : 'text-body-2 text-neutral-500'}`} >
											پربازدیدترین
										</span>
										<span onClick={() => handleSort("3")} className={`cursor-pointer whitespace-nowrap ${sort === '3' ? 'text-body2-strong text-primary-700' : 'text-body-2 text-neutral-500'}`} >
											جدیدترین
										</span>
										<span onClick={() => handleSort("4")} className={`cursor-pointer whitespace-nowrap ${sort === '4' ? 'text-body2-strong text-primary-700' : 'text-body-2 text-neutral-500'}`} >
											ارزان‌ترین
										</span>
										<span onClick={() => handleSort("5")} className={`cursor-pointer whitespace-nowrap ${sort === '5' ? 'text-body2-strong text-primary-700' : 'text-body-2 text-neutral-500'}`} >
											گران‌ترین
										</span>									
									</div>
									<div className="mr-auto block">
										<span className="text-neutral-500 whitespace-nowrap text-body-2 ellispis-1 xl:flex items-center gap-2">{toPersianDigits(productCount)} کالا
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
						
					<div className="product-list_ProductList__pagesContainer__zAhrX product-list_ProductList__pagesContainer--withSidebar__17nz1 product-list_ProductList__pagesContainer--withoutSidebar__aty9j">
						{
							products && products.map((product, index) => (
								<div className="product-list_ProductList__item__LiiNI" data-product-index="1">
									<Link to={`/product/${product.slug}/${product.title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`} className="block cursor-pointer relative bg-neutral-000 overflow-hidden grow py-3 px-4 lg:px-2 h-full styles_VerticalProductCard--hover__ud7aD">
										<div data-testid="product-card" className="h-full">
											<article className="overflow-hidden flex flex-col items-stretch justify-start h-full">
												<div className="flex items-center justify-start mb-1">
													<div className="text-body2-extra grow">
														<br />
													</div>
												</div>
												<div className="flex grow relative flex-col">
													<div className="">
														<div className="flex items-stretch flex-col relative mb-1">
															<div className="flex items-start mx-auto">
																<div>
																	<div style={{width: '240px', height: '240px', lineHeight: '0'}}>
																		<LazyLoadImage src={IMAGE_ADDRESS + product.image} className="w-full rounded-medium inline-block" />
																		{/*<picture>
																			<source type="image/webp" srcset="https://dkstatics-public.digikala.com/digikala-products/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg?x-oss-process=image/resize,m_lfit,h_300,w_300/format,webp/quality,q_80" />
																			<source type="image/jpeg" srcset="https://dkstatics-public.digikala.com/digikala-products/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg?x-oss-process=image/resize,m_lfit,h_300,w_300/quality,q_80" />
																			<img className="w-full rounded-medium inline-block" src="https://dkstatics-public.digikala.com/digikala-products/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg?x-oss-process=image/resize,m_lfit,h_300,w_300/quality,q_80" width="240" height="240" alt="گوشی موبایل اپل مدل iPhone 16 CH دو سیم کارت ظرفیت 128 گیگابایت و رم 8 گیگابایت" title="" style={{objectFit: 'contain'}} />
																		</picture>*/}
																	</div>
																</div>
																{product.colors &&
																<div className="flex items-center justify-center gap-2 absolute top-0 left-0 flex-col p-1 bg-neutral-000 style_ProductImage__colors--topLeft__iHRie">
																	{
																		product.colors.split(",").map((color, colorIndex) => (
																			<span className="rounded-circle inline-block color_Color__l0PYL border-complete-200" style={{backgroundColor: `#${color}`, width: '8px', height: '8px'}}>
																			</span>
																		))
																	}
																	{/*<div className="flex">
																		<svg style={{ width: '8px', height: '8px', fill: 'var(--color-icon-black)'}}>
																			<use xlinkHref="#addSimple"></use>
																		</svg>
																	</div>*/}
																</div>
																}
															</div>
														</div>
													</div>
													<div className="grow flex flex-col items-stretch justify-start">
														<div className="flex items-center justify-start gap-1 flex-wrap mb-1">
															<br />
															<br />
														</div>
														<div>
															<h3 className="ellipsis-2 text-body2-strong text-neutral-700 styles_VerticalProductCard__productTitle__6zjjN">{product.title}</h3>
														</div>
														<div className="mb-1 flex items-center justify-between">
															<div className="flex items-center" data-ab-id="">
																{/*<p className="text-caption text-primary-700">تنها ۱ عدد در انبار باقی مانده
																</p>
																<br />*/}
															</div>
															<div className="flex items-center">
																{/*<p className="text-body2-strong text-neutral-700">۴.۴
																</p>
																<div className="flex mr-2 shrink-0">
																	<svg style={{ width: '16px', height: '16px', fill: 'var(--color-icon-rating-0-2)'}}>
																		<use xlinkHref="#starFill"></use>
																	</svg>
																</div>*/}
															</div>
														</div>
														<div className="pt-1 flex flex-col items-stretch justify-between">
															<div className="flex items-center justify-between">
																{ product.discount !== null &&
																<div className="px-1 text-white rounded-large flex items-center justify-center ProductPrice_ProductPrice__discountWrapper__1Ru_1 bg-hint-object-error">
																	<span className="text-body2-strong" data-testid="price-discount-percent">{toPersianDigits(product.discount)}٪</span>
																</div>
																}
																<div className="flex items-center justify-end gap-1 text-neutral-700 text-neutral-400 text-h5 grow">
																	<span data-testid="price-final">{product.price ? toPersianDigits(product.priceNum) : 'ناموجود'}
																	</span>
																	{product.price ?
																	<div className="flex">
																		<svg style={{ width: '16px', height: '16px', fill: 'var(--color-icon-high-emphasis)'}}>
																			<use xlinkHref="#toman"></use>
																		</svg>
																	</div>
																	:''
																	}
																</div>
															</div>
															<div className="flex items-center justify-between pl-5">
																{ product.oldPrice !== null &&
																<div data-testid="price-no-discount" className="text-neutral-300 line-through self-end mr-auto text-body-2">
																	{toPersianDigits(product.oldPriceNum)}
																</div>
																}
															</div>
														</div>
													</div>
												</div>
											</article>
										</div>
									</Link>
								</div>
							))
						}
					</div>
							

				</section>
				<section className="flex flex-col product-list_ProductList__sidebar__N_suS">
					<div className="sticky-outer-wrapper z-1" >
						<div className="sticky-inner-wrapper" style={{ position: 'relative', top: '0px'}}>
							<div className="lg:w-full lg:border-complete-200 lg:rounded-medium bg-neutral-000 styles_list__CQc6l">
								<div className="w-full hidden lg:block px-5 lg:px-0 py-4 text-h4 !lg:px-5">
									<div className="w-full flex items-center justify-start">
										<div>
										</div>
										<div className="grow text-neutral-700">فیلترها
										</div>
										<div>
										</div>
									</div>
								</div>
								
								{
									filters.map((filter, index) => (
										<div key={index} onClick={() => handleToggleFilterOptions(index)} className="w-full lg:px-5">
											<div className="w-full flex items-center justify-start cursor-pointer">
												<div>
												</div>
												<div className="grow text-neutral-700">
													<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
														<div className="flex items-center justify-between w-full">
															<div className="text-subtitle-strong flex items-center">{filter.title}
															</div>
															<div className="flex lg:hidden">
																<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
																	<use xlinkHref="#chevronLeft"></use>
																</svg>
															</div>
															<div className="flex hidden lg:inline-block text-neutral-400">
																<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
																	<use xlinkHref="#expandMore"></use>
																</svg>
															</div>
														</div>
													</div>
												</div>
												<div>
												</div>
											</div>
											{filter.showOptions &&
												<div class="lg:overflow-y-auto pt-1 styles_PLPFilterExpandableFilter__child__Qz3Qu lg:px-5" onClick={(e) => {e.stopPropagation(); }}>
													{
														filter.options.map((option, optionIndex) => (
															<div key={optionIndex} class="w-full" onClick={(e) => {e.stopPropagation(); }}>
																<div class="w-full flex items-center justify-start">
																	<div>
																		<label htmlFor={`filter-${index}-option-${optionIndex}`} class="flex items-center cursor-pointer styles_Checkbox__checkboxContainer__7joRB py-1 ml-4">
																			<input class="invisible absolute" type="checkbox" id={`filter-${index}-option-${optionIndex}`} checked={option.isSelect} onChange={(e) => {e.stopPropagation(); handleToggleOptionItemSelect(optionIndex, index)}} />
																			<span class="inline-flex justify-center items-center cursor-pointer rounded-small shrink-0 styles_Checkbox__checkbox__z1B5a styles_Checkbox__checkbox--secondary__FspFz">
																				<div class="flex styles_Checkbox__icon__AaKB1">
																					<svg style={{width: '10px', height: '10px', fill: 'var(--color-icon-white)'}}>
																						<use xlinkHref="#check"></use>
																					</svg>
																				</div>
																			</span>
																		</label>
																	</div>
																	<div class="grow text-neutral-700">
																		<label for="302" class="w-full flex items-center justify-between py-3 lg:pl-3 border-complete-b">
																			<div class="text-subtitle-strong">{option.title}
																			</div>
																		</label>
																	</div>
																	<div>
																	</div>
																</div>
															</div>
														))
													}
												</div>
											}
										</div>
									))
								}

								{/* <div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">رنگ
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<label for="17" className="text-subtitle-strong flex items-center cursor-pointer">
														<div className="flex items-center justify-start flex-wrap">ارسال امروز
															<span className="grow-0 mr-2">
																<div style={{ width: '18px', height: '18px', lineHeight: '0'}}>
																	<img className="w-full inline-block" src="https://dkstatics-public.digikala.com/digikala-static/262c38c0e4990522af759e0016a287508bbc84f6_1684761217.png" width="18" height="18" alt="" title="" style={{objectFit: 'contain'}} />
																</div>
															</span>
														</div>
													</label>
													<label className="inline-block relative cursor-pointer styles_switchInput__3SIkm mr-4 PLPFilterListSwitchFilter_PLPFilterSwitchFilter__switch__sJyZL">
														<input className="hidden absolute" type="checkbox" id="17" />
														<span className="block bg-neutral-400 absolute rounded-circle styles_switchInput__slider__NUrot">
														</span>
														<span className="block w-full relative h-full styles_switchInput__track__ftJN8 styles_switchInput__track--border--400__474Fy">
														</span>
													</label>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<label for="18" className="text-subtitle-strong flex items-center cursor-pointer">
														<div className="flex items-center justify-start flex-wrap">ارسال فروشنده
															<span className="grow-0 mr-2">
																<div style={{ width: '18px', height: '18px', lineHeight: '0'}}>
																	<img className="w-full inline-block" src="https://dkstatics-public.digikala.com/digikala-static/7fd084adca1efff834cdd871cb97a0307c0f8c51_1700488931.svg" width="18" height="18" alt="" title="" style={{objectFit: 'contain'}} />
																</div>
															</span>
														</div>
													</label>
													<label className="inline-block relative cursor-pointer styles_switchInput__3SIkm mr-4 PLPFilterListSwitchFilter_PLPFilterSwitchFilter__switch__sJyZL">
														<input className="hidden absolute" type="checkbox" id="18" />
														<span className="block bg-neutral-400 absolute rounded-circle styles_switchInput__slider__NUrot">
														</span>
														<span className="block w-full relative h-full styles_switchInput__track__ftJN8 styles_switchInput__track--border--400__474Fy">
														</span>
													</label>
												</div>
												<div className="ellipsis-1 text-body-1 text-neutral-500">ارسال مستقیم و سریع‌تر
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">محدوده قیمت
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<label for="19" className="text-subtitle-strong flex items-center cursor-pointer">
														<div className="flex items-center justify-start flex-wrap">فقط کالاهای موجود
														</div>
													</label>
													<label className="inline-block relative cursor-pointer styles_switchInput__3SIkm mr-4 PLPFilterListSwitchFilter_PLPFilterSwitchFilter__switch__sJyZL">
														<input className="hidden absolute" type="checkbox" id="19" />
														<span className="block bg-neutral-400 absolute rounded-circle styles_switchInput__slider__NUrot">
														</span>
														<span className="block w-full relative h-full styles_switchInput__track__ftJN8 styles_switchInput__track--border--400__474Fy">
														</span>
													</label>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<label for="20" className="text-subtitle-strong flex items-center cursor-pointer">
														<div className="flex items-center justify-start flex-wrap">فقط کالاهای موجود در انبار کوچی
														</div>
													</label>
													<label className="inline-block relative cursor-pointer styles_switchInput__3SIkm mr-4 PLPFilterListSwitchFilter_PLPFilterSwitchFilter__switch__sJyZL">
														<input className="hidden absolute" type="checkbox" id="20" />
														<span className="block bg-neutral-400 absolute rounded-circle styles_switchInput__slider__NUrot">
														</span>
														<span className="block w-full relative h-full styles_switchInput__track__ftJN8 styles_switchInput__track--border--400__474Fy">
														</span>
													</label>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">نوع فروشنده
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">سیستم عامل
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">شبکه‌های مخابراتی
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">حس‌گرها
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">تکنولوژی‌های مکان‌یابی (GPS)
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">نوع سیم کارت
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">درگاه‌های ارتباطی
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">رزولوشن دوربین اصلی
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">نوع گوشی موبایل
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">بازه‌ اندازه صفحه نمایش
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">پشتیبانی از کارت حافظه
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">دسته ‌بندی
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">تعداد سیم کارت
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">فناوری صفحه‌ نمایش
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">فناوری فوکوس
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">محدوده نرخ بروزرسانی تصویر (refresh rate)
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">محدوده وزنی
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">محدوده ظرفیت باتری
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">نوع محافظ صفحه نمایش گوشی
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">مقدار RAM
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">تعداد دوربین‌های پشت گوشی
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">قابلیت‌های شارژ
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">حافظه داخلی
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">قابلیت‌های مقاومتی
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start cursor-pointer">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div data-cro-id="plp-filter-drop-down" className="relative w-full flex flex-col items-start py-3 border-complete-b">
												<div className="flex items-center justify-between w-full">
													<div className="text-subtitle-strong flex items-center">ریجن
													</div>
													<div className="flex lg:hidden">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
													<div className="flex hidden lg:inline-block text-neutral-400">
														<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#expandMore"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
								<div className="w-full lg:px-5">
									<div className="w-full flex items-center justify-start">
										<div>
										</div>
										<div className="grow text-neutral-700">
											<div className="relative w-full flex flex-col items-start py-3">
												<div className="flex items-center justify-between w-full">
													<label for="21" className="text-subtitle-strong flex items-center cursor-pointer">
														<div className="flex items-center justify-start flex-wrap">خرید حضوری در تهران
															<span className="grow-0 mr-2">
																<div style={{ width: '18px', height: '18px', lineheight: '0'}}>
																	<img className="w-full inline-block" src="https://dkstatics-public.digikala.com/digikala-static/bb58fcdbbe6895197929f6cc3d7f1347643dea93_1738407764.png" width="18" height="18" alt="" title="" style={{objectFit: 'contain'}} />
																</div>
															</span>
														</div>
													</label>
													<label className="inline-block relative cursor-pointer styles_switchInput__3SIkm mr-4 PLPFilterListSwitchFilter_PLPFilterSwitchFilter__switch__sJyZL">
														<input className="hidden absolute" type="checkbox" id="21" />
														<span className="block bg-neutral-400 absolute rounded-circle styles_switchInput__slider__NUrot">
														</span>
														<span className="block w-full relative h-full styles_switchInput__track__ftJN8 styles_switchInput__track--border--400__474Fy">
														</span>
													</label>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div> */}
							</div>
							<div className="py-3">
							</div>
						</div>
					</div>

				</section>
			</div>
			<div className="z-2 flex flex-col hide-scrollbar styles_Layout__jJdiO hidden">
				<div className="grow bg-neutral-000 lg:rounded-large flex flex-col overflow-hidden styles_Layout__content__nlhKE">
					<header className="w-full bg-primary-500 text-white px-5 py-2">
						<div className="flex items-center justify-between">
							<h2 className="text-h4">پشتیبانی آنلاین</h2>
							<div className="flex cursor-pointer">
								<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-white)'}}>
									<use xlinkHref="#arrowLeft"></use>
								</svg>
							</div>
						</div>
					</header>
					<div className="">
					</div>
				</div>
			</div>
			<div className="relative">
				<button className="flex items-center justify-between text-button-1 styles_FabButton__5YQgj styles_FabButton--medium__5dCWs styles_FabButton--primary__fBOaQ p-3 fixed inline-block z-1 bottom-8 styles_Layout__CTAButton__WsxR_">
					<div className="flex items-center justify-center">
						<div className="flex styles_FabButton__icon__Nx9Sr">
							<svg style={{ width: '24px', height: '24px', fill: 'var(--color-icon-white)'}}>
								<use xlinkHref="#support"></use>
							</svg>
						</div>
					</div>
				</button>
			</div>
		</div>

    );
}

export default ProductsDesktop;